<template>
  <b-col class="uk-visible@l uk-height-1-1 main-container">
    <div class="uk-flex uk-margin-remove-left uk-height-1-1">
      <!--Основное блок -->
      <DesktopContent class="main-content"></DesktopContent>
    </div>
  </b-col>
</template>

<script>
import DesktopContent from '@/views/layout/desktop/content/DesktopContent'

export default {
  name: 'DesktopMainBlock',
  components: {DesktopContent}
}
</script>
